import { render, staticRenderFns } from "./AttachmentsSection.vue?vue&type=template&id=47b2c664&scoped=true"
import script from "./AttachmentsSection.vue?vue&type=script&lang=js"
export * from "./AttachmentsSection.vue?vue&type=script&lang=js"
import style0 from "./AttachmentsSection.vue?vue&type=style&index=0&id=47b2c664&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b2c664",
  null
  
)

export default component.exports